import { Fragment } from 'react'
import { Filter } from './types'
import { DesktopFilters } from './desktop-filters'
import { MobileFilters } from './mobile-filters'

export type FiltersProps = {
  filters: Filter[]
}

export function Filters({ filters }: FiltersProps) {
  return (
    <Fragment>
      <div className="hidden sm:block">
        <DesktopFilters filters={filters} />
      </div>
      <div className="block sm:hidden">
        <MobileFilters filters={filters} />
      </div>
    </Fragment>
  )
}
